export default "__VITE_ASSET__Cx_NXcDG__"